var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0709 5.31388L12.0209 0.363882C12.1131 0.268372 12.2235 0.19219 12.3455 0.139781C12.4675 0.0873716 12.5987 0.0597853 12.7315 0.0586315C12.8643 0.0574777 12.996 0.0827794 13.1189 0.13306C13.2417 0.183341 13.3534 0.257594 13.4473 0.351487C13.5412 0.44538 13.6154 0.557032 13.6657 0.679928C13.716 0.802824 13.7413 0.934504 13.7402 1.06728C13.739 1.20006 13.7114 1.33128 13.659 1.45329C13.6066 1.57529 13.5304 1.68564 13.4349 1.77788L7.7779 7.43488C7.59037 7.62235 7.33606 7.72767 7.0709 7.72767C6.80574 7.72767 6.55143 7.62235 6.3639 7.43488L0.7069 1.77788C0.611389 1.68564 0.535207 1.57529 0.482798 1.45329C0.430389 1.33128 0.402803 1.20006 0.401649 1.06728C0.400495 0.934504 0.425797 0.802824 0.476078 0.679928C0.526359 0.557032 0.600612 0.44538 0.694505 0.351487C0.788397 0.257594 0.900049 0.183341 1.02295 0.13306C1.14584 0.0827794 1.27752 0.0574777 1.4103 0.0586315C1.54308 0.0597853 1.6743 0.0873716 1.7963 0.139781C1.91831 0.19219 2.02865 0.268372 2.1209 0.363882L7.0709 5.31388Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.fd66f57ce3334df4a90a8b23422ba064.svg";
export { ForwardRef as ReactComponent };